import { MapPin, Calendar, Wallet, ArrowRight, Clock, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import toast from 'react-hot-toast';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function PopularDep() {
    const navigate = useNavigate();

    const trips = [
        {
            title: "Lepakshi Temple (Veerabhadra Temple)",
            tag: "Heritage",
            duration: "Full Day",
            type: "Royal Architecture",
            description: "Explore the timeless heritage of Lepakshi Temple, a 16th-century architectural marvel famous for its mysteries and stunning stone art.",
            highlights: [
                "The legendary Hanging Pillar that defies gravity",
                "Massive monolithic Nandi carved from a single granite rock",
                "Sacred 7-headed Naga Lingam",
                "Beautiful Vijayanagara-style murals and stone carvings",
                "Strong cultural and mythological significance"
            ],
            status: "Coming Soon",
            shortVersion: "Lepakshi Temple Tour – Coming Soon | Famous for the Hanging Pillar & Monolithic Nandi"
        },
        {
            title: "Adiyogi - The Source of Yoga",
            tag: "Spiritual",
            duration: "Full Day",
            type: "Light & Sound Show",
            description: "Experience the mesmerizing Adiyogi 3D Light & Sound Show at Chikkaballapur — a powerful spiritual experience combining laser visuals, music, chants, and Sadhguru's narration.",
            highlights: [
                "Stunning 3D laser light show",
                "Spiritual music, chanting, and narration",
                "Show starts around 7:00–7:15 PM",
                "Best to arrive early due to high crowd on weekends"
            ],
            status: "Coming Soon",
            shortVersion: "Adiyogi Light Show – Coming Soon | 3D Laser | Music | Spiritual Experience"
        }
    ];

    const handleLearnMore = (tripTitle) => {
        toast.success(`${tripTitle} - Coming Soon! `, {
            duration: 3000,
            position: 'top-center',
            style: {
                background: '#4f46e5',
                color: '#fff',
                padding: '16px',
                borderRadius: '10px',
                fontSize: '14px',
                fontWeight: '600',
            },
            icon: '',
        });
    };

    return (
        <section className="bg-gradient-to-b from-slate-50 to-white py-18">
            <div className="max-w-7xl mx-auto px-6 py-2">
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-slate-900">
                        Upcoming <span className="text-indigo-600">Trips</span>
                    </h2>
                </div>

                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={32}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    }}
                    className="!pb-16"
                >
                    {trips.map((trip, index) => (
                        <SwiperSlide key={index}>
                            <div className="relative bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-xl transition-all duration-300 group h-full">
                                {/* Badge */}
                                <span className="absolute top-4 right-4 bg-indigo-50 text-indigo-600 text-xs font-semibold px-3 py-1 rounded-full">
                                    {trip.tag}
                                </span>

                                {/* Icon */}
                                <div className="w-12 h-12 rounded-xl bg-indigo-100 flex items-center justify-center mb-5">
                                    <MapPin className="text-indigo-600" />
                                </div>

                                {/* Title */}
                                <h3 className="text-xl font-bold text-slate-900 mb-2">
                                    {trip.title}
                                </h3>

                                <p className="text-sm text-slate-600 mb-4">
                                    {trip.description}
                                </p>

                                {/* Divider */}
                                <div className="h-px bg-slate-200 mb-4"></div>

                                {/* Info Row */}
                                <div className="space-y-3 text-sm text-slate-700 mb-6">
                                    <div className="flex items-center gap-2">
                                        <Clock size={16} className="text-indigo-500" />
                                        {trip.duration}
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <MapPin size={16} className="text-indigo-500" />
                                        {trip.type}
                                    </div>
                                </div>

                                {/* CTA */}
                                <button 
                                    onClick={() => handleLearnMore(trip.title)}
                                    className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-slate-900 text-white font-semibold text-sm hover:bg-indigo-600 transition-colors"
                                >
                                    Learn More <ArrowRight size={16} />
                                </button>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <style jsx>{`
                .swiper-button-next,
                .swiper-button-prev {
                    color: #4f46e5;
                    background: white;
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
                }
                
                .swiper-button-next:after,
                .swiper-button-prev:after {
                    font-size: 20px;
                    font-weight: bold;
                }

                .swiper-pagination-bullet {
                    background: #cbd5e1;
                    opacity: 1;
                    width: 12px;
                    height: 12px;
                }

                .swiper-pagination-bullet-active {
                    background: #4f46e5;
                    width: 32px;
                    border-radius: 6px;
                }
            `}</style>
        </section>
    );
}